module.exports = __webpack_public_path__ + "img/B7.5a96da8d.svg";